import { LayoutGrid } from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';
import type { ReactElement } from 'react';

import DeviceWrapper from './DeviceWrapper';

interface FeatureHighlightProps {
  readonly deviceContent: ReactElement;
  readonly contentElement: ReactElement;
  readonly reverse?: boolean | undefined;
}

const FeatureHighlight = ({
  deviceContent,
  contentElement,
  reverse = false,
}: FeatureHighlightProps): JSX.Element => {
  return (
    <div className="py-8">
      <LayoutGrid className="items-center gap-y-8">
        <div
          className={cx('col-main text-center md:col-span-12 md:row-start-1', {
            'md:col-end-main': reverse,
            'md:col-start-main': !reverse,
          })}
        >
          <DeviceWrapper>{deviceContent}</DeviceWrapper>
        </div>
        <div
          className={cx('col-main text-left md:col-span-7 md:row-start-1', {
            'md:col-start-3 lg:col-start-4': reverse,
            'md:col-end-22': !reverse,
          })}
        >
          {contentElement}
        </div>
      </LayoutGrid>
    </div>
  );
};

export default FeatureHighlight;
